import { TransferListItem } from '@aibees/shared/features';
import { Responders } from 'react-beautiful-dnd';

export function useOnDragEnd(
  items: TransferListItem[],
  onChange: (items: TransferListItem[]) => void
) {
  const onDragEnd: Responders['onDragEnd'] = ({
    source,
    destination,
    draggableId,
  }) => {
    if (
      !destination ||
      (destination.droppableId === source.droppableId &&
        destination.index === source.index)
    )
      return;

    const newColumns = [...items];
    newColumns.splice(source.index, 1);
    const draggedElement = items.find(
      (el) => el.id === draggableId
    ) as TransferListItem;
    newColumns.splice(destination.index, 0, draggedElement);
    onChange(newColumns);
  };
  return onDragEnd;
}
